function ConfirmOrderMessage() {
  return (
    <div className="flex flex-col items-center h-[700px] " style={{background:" linear-gradient(to top right,#d4f8e8,#ffffff) "}} >
      <h1 className="text-5xl font-extrabold text-green-700 mb-6 drop-shadow-lg mt-[100px]   ">
        Thank You!
      </h1>
      <div className="mb-6">
        <i className="fas fa-check-circle text-green-500 text-6xl drop-shadow-md  "></i>
      </div>
      <p className="text-xl text-gray-700 font-medium text-center">
        Your order has been{" "}
        <span className="text-green-600 font-semibold">
          Confirmed!
        </span>{" "}
        We’ll notify you once your order is on its way.
      </p>
    </div>
  );
}

export default ConfirmOrderMessage;
